import React from 'react'
import { motion } from "framer-motion";

const ResoucesHero = () => {
  return (
    <section className="about-hero">

      <div className="hero-container">

        {/* LEFT */}
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2 className="hero_head">
           Turn Ideas Into Impact
          </h2>

          <p className="hero-text">
           Stay ahead with curated insights on technology, design, and digital transformation.
          </p>

        </motion.div>

       
        <div className="hero-right">

           <div className="blob">
            <img className="cover-img"
              src="./blog-hero.webp"
              alt="team"
              loading='lazy'
            />
          </div>

        </div>

      </div>
    </section>
  )
}

export default ResoucesHero